import script from "./Wizard.vue?vue&type=script&setup=true&lang=js"
export * from "./Wizard.vue?vue&type=script&setup=true&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=1691f2df&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1691f2df"]])

export default __exports__